import Button from "../components/Button";
import bigLogo from "../../src/assets/svg/big-logo.svg";

const NotFound = () => {
  return (
    <div className="flex flex-col items-center w-full gap-10 pt-[120px] sm:pt-[140px] px-6 pb-8">
      {/* Upper half*/}
      <div className="flex flex-col items-center w-full pb-10 border-b border-extra-light">
        <div className="flex flex-col gap-6">
          <img src={bigLogo} alt="Page not found" className="h-[120px]"></img>
          <p className="font-bold text-center text-[40px] sm:text-[50px] text-primary-red">
            404
          </p>
        </div>
      </div>

      {/* Lower half*/}
      <div className="flex flex-col items-center gap-10 max-w-[521px]">
        <div className="flex flex-col gap-4">
          <h1 className="text-lg font-bold text-center">
            Nepostojeća stranica
          </h1>
          <span className="text-sm text-center text-opacity-80">
            Čini se da ova stranica trenutno ne postoji. Pokušajte ponovno, ili
            se vratite na početnu stranicu.
          </span>
        </div>
        {/* Navigation button */}
        <a href="https://www.alfaromeo.hr/" className="w-full">
          <Button
            text={"Natrag na početnu stranicu"}
            variant={"primary"}
            size={"base"}
            width="w-full"
          ></Button>
        </a>
      </div>
    </div>
  );
};

export default NotFound;
